import {useSelector} from "react-redux";

interface IProps {
    sendExampleQn: (qn: string) => void,
    extraClass: string
}

export const Example = (props: IProps) => {
    const {sendExampleQn, extraClass} = props;
    const suggestedQuestions = useSelector((state: any) => state.questionReducer.suggestedQuestions);

    return (
        <div className={`m-chat-example-chat-wrapper fade-in-text ${extraClass}`}>
            <div className='m-chat-exapmple-chat-container'>
                <div className="m-chat-example-list-wrapper">
                    <div className="m-chat-example-list-container">
                        {suggestedQuestions.map((ex: string, i: number) => (
                            <div className="m-chat-example-list-item" key={'examples' + i}
                                 onClick={() => sendExampleQn(ex)}>
                                <div className="m-chat-example-list-text">{ex}</div>
                                <span className="m-chat-example-list-icon">
                                    <svg width="20px" height="20px"
                                         viewBox="0 0 24 24" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M12 6V18M12 6L7 11M12 6L17 11"
                                            stroke="#000000" strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"></path>
                                    </svg>
                                </span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}
